/**
 * WorkspacePage Component
 * Main page for managing research workspaces
 */

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { WorkspaceList } from '@components/workspaces/WorkspaceList'
import { workspacesAPI } from '@/api/workspaces'
import { logError } from '@utils/logger'
import toast from 'react-hot-toast'

const WorkspacePage: React.FC = () => {
  const navigate = useNavigate()
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleCreateWorkspace = async () => {
    // Create workspace directly without modal
    try {
      const workspace = await workspacesAPI.createWorkspace({
        query: '', // Empty query - user will enter it in the workspace view
      })
      // Navigate directly to workspace page
      navigate(`/workspaces/${workspace.workspace_id}`)
    } catch (error) {
      logError('Error creating workspace:', error)
      toast.error('Failed to create workspace')
    }
  }

  const handleSelectWorkspace = (workspaceId: string) => {
    navigate(`/workspaces/${workspaceId}`)
  }

  return (
    <div className="h-full flex flex-col bg-slate-50 dark:bg-slate-900">
      <WorkspaceList
        onCreateWorkspace={handleCreateWorkspace}
        onSelectWorkspace={handleSelectWorkspace}
        refreshTrigger={refreshTrigger}
      />
    </div>
  )
}

export default WorkspacePage

